import type { RouteLocationNormalizedLoadedGeneric } from "vue-router";

/**
 * 获取 decode 后的 pathname，包含 hash 等
 * @param path 路径
 */
export const getDecodePathname = (path: string) => {
    const dPath = decodeURIComponent(path);
    // 路由带hash
    if (dPath?.includes('#')) {
        return dPath.split('?')[0] + dPath.split('#')[1]
    }
    // 菜单不带hash
    if (dPath?.includes('?')) {
        return dPath.split('?')[0];
    }
    return dPath
}

export const equalToRoute = (menuPath?: string, routeObj?: RouteLocationNormalizedLoadedGeneric,  routePath?: string) => {
    if (!menuPath) {
        return false;
    }
    let path = routePath || ''
    if (!path && routeObj) {
        path = routeObj.path;
    }
    const dMenuPath = decodeURIComponent(menuPath);
    const dRoutePath = decodeURIComponent(path);
    // 路由带hash
    if (dMenuPath.includes('#') && dRoutePath.includes('#')) {
        if (dMenuPath?.split('?')[0] + dMenuPath.split('#')[1] === dRoutePath?.split('?')[0] + dRoutePath.split('#')[1]) {
            return true;
        } else {
            return false;
        }
    }
    // 菜单不带hash
    if (dMenuPath?.split('?')[0] === dRoutePath?.split('?')[0]) {
        return true;
    }
    return false;
}
